import { GameVars } from "../../../GameVars";
import { CategoryContainer } from "./CategoryContainer";

export class CategoriesContainer extends Phaser.GameObjects.Container {

    public static readonly CATEGORIES_DATA: {
        key: string,
        name: string, p: {x: number, y: number}, 
        boundingBox: {x: number, y: number, w: number, h: number},
        patch: {name: string, p: {x: number, y: number}},
        orderAlphaTween: number,
        markerPosition: {x: number, y: number, scale: number}
        }[] = [
            {key: "PLANTS", name: "Plants", p: {x: 1020, y: 758}, boundingBox: {x: 0, y: -125, w: 220, h: 270}, patch: {name: "patch_plants", p: {x: 12, y: -145}}, orderAlphaTween: 3, markerPosition: {x: -4, y: -145, scale: .55}},
            {key: "BUILDINGS", name: "Buildings", p: {x: 1220, y: 306}, boundingBox: {x: 0, y: -110, w: 160, h: 180}, patch: {name: "patch_buildings", p: {x: 14, y: -118}}, orderAlphaTween: 4, markerPosition: {x: 5, y: -90, scale: .4}},
            {key: "PYRAMIDS", name: "Pyramids", p: {x: 1220, y: 486}, boundingBox: {x: 0, y: -70, w: 160, h: 150}, patch: {name: "patch_pyramids", p: {x: 2, y: -90}}, orderAlphaTween: 4, markerPosition: {x: 4, y: -75, scale: .4}},
            {key: "ANIMALS", name: "Animals", p: {x: 1520, y: 782}, boundingBox: {x: 0, y: -80, w: 170, h: 160}, patch: {name: "patch_animals", p: {x: -9, y: -112}}, orderAlphaTween: 7, markerPosition: {x: -10, y: -110, scale: .4}},
            {key: "SYMBOLS", name: "Symbols", p: {x: 752, y: 690}, boundingBox: {x: 0, y: -170, w: 180, h: 360}, patch: {name: "patch_symbols", p: {x: 0, y: -180}}, orderAlphaTween: 1, markerPosition: {x: 0, y: -180, scale: .65}},
            {key: "ZODIAC", name: "Zodiac", p: {x: 1320, y: 748}, boundingBox: {x: 0, y: -100, w: 190, h: 200}, patch: {name: "patch_zodiac", p: {x: 2, y: -112}}, orderAlphaTween: 5, markerPosition: {x: 0, y: -125, scale: .5}},
            {key: "LETTERS", name: "Letters", p: {x: 915, y: 306}, boundingBox: {x: 0, y: -100, w: 240, h: 210}, patch: {name: "patch_letters", p: {x: 10, y: -102}}, orderAlphaTween: 2, markerPosition: {x: 0, y: -100, scale: .55}},
            {key: "CLASSIC", name: "Classic", p: {x: 1610, y: 316}, boundingBox: {x: 0, y: -100, w: 160, h: 200}, patch: {name: "patch_classic", p: {x: -2, y: -114}}, orderAlphaTween: 8, markerPosition: {x: -8, y: -115, scale: .4}},
            {key: "THINGS", name: "Things", p: {x: 1400, y: 402}, boundingBox: {x: 0, y: -180, w: 160, h: 390}, patch: {name: "patch_things", p: {x: 5, y: -200}}, orderAlphaTween: 6, markerPosition: {x: 0, y: -255, scale: .4}},
            {key: "FORMS", name: "Forms", p: {x: 1642, y: 610}, boundingBox: {x: 0, y: -100, w: 200, h: 180}, patch: {name: "patch_forms", p: {x: 24, y: -120}}, orderAlphaTween: 9, markerPosition: {x: -5, y: -115, scale: .5}}
    ];

    public static f: number;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        CategoriesContainer.f = 0;

        this.scaleX = GameVars.scaleX;

        const levelTitleBackground = new Phaser.GameObjects.Image(this.scene, 620, 42, "texture_atlas_1", "tab_boards_daily_games");
        levelTitleBackground.setOrigin(0);
        this.add(levelTitleBackground);

        const allBoardsLahel = new Phaser.GameObjects.Text(this.scene, levelTitleBackground.x + 20 , levelTitleBackground.y + 12.8, gameText.ALL_BOARDS[lan], {fontFamily: "OpenSans-CondLight", fontSize: "40px", color: "#7C5D46"});
        allBoardsLahel.setOrigin(0);
        this.add(allBoardsLahel);

        if (allBoardsLahel.width > 280){
            allBoardsLahel.setScale(280 / allBoardsLahel.width);
        }

        const unlockedLevelsCounterLabelStr = "(" + GameVars.unlockedBoards + "/" + GameVars.boardsData.length + ")";

        const unlockedLevelsCounterLabel = new Phaser.GameObjects.Text(this.scene, allBoardsLahel.x, allBoardsLahel.y + 58, unlockedLevelsCounterLabelStr, {fontFamily: "OpenSans-CondLight", fontSize: "24px", color: "#7C5D46"});
        unlockedLevelsCounterLabel.setOrigin(0, .5);
        this.add(unlockedLevelsCounterLabel);

        CategoriesContainer.CATEGORIES_DATA.forEach((cat, index) => {
            const categoryContainer = new CategoryContainer(scene, cat.name, index + 1);
            categoryContainer.x = cat.p.x;
            categoryContainer.y = cat.p.y;
            this.add(categoryContainer);
        });

        this.scene.events.on("preupdate", this.preUpdate, this);
    }

    private preUpdate(): void {

        CategoriesContainer.f ++;

        if (CategoriesContainer.f === 10 * 9 + 1) {
            CategoriesContainer.f = 0;
        }
    }
}
